/** @jsx jsx */

import { Surface, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';
import { getTeamUrl } from 'app/developer-v3/utils';

const Styles = {
  container: css`
    padding: 20px 25px;
  `,
  list: css`
    list-style: disc;
    padding-left: 20px;
    margin-bottom: 0px;
  `,
  code: css`
    padding: 0px;
    background: none;
    font-size: inherit;
    border: none;
  `,
};

type Props = {
  integrationId: number;
};

export default function ContactDetailsHelp({ integrationId }: Props) {
  return (
    <Surface backgroundColor="GrayWarm2" borderColor="GrayWarm4">
      <aside css={Styles.container}>
        <Text margin="10px 0px" tag="h3" type="Body4">
          What is this?
        </Text>
        <Text>
          Having dedicated contacts ensures we reach the right person on your
          team quickly, whether it's about a technical issue, marketing
          opportunity, or a security concern. Here's how we'll use each:
        </Text>
        <ul css={Styles.list}>
          <li>
            <Text>
              <Text fontWeight={600}>Marketing contact:</Text> We'll share
              launch details, co-marketing opportunities, and promotional
              updates about your integration.
            </Text>
          </li>
          <li>
            <Text>
              <Text fontWeight={600}>Security contact:</Text> We'll notify them
              of any security-related issues, vulnerability disclosures, or
              urgent incidents affecting your integration.
            </Text>
          </li>
          <li>
            <Text>
              <Text fontWeight={600}>Technical contact:</Text> We'll reach out
              with troubleshooting questions or technical updates about your
              integration.
            </Text>
          </li>
        </ul>
        <br></br>
        <Text>
          All contacts must be an Admin on your integration team. If your
          desired contacts aren't already team members, go to the{' '}
          <Link href={getTeamUrl(integrationId)}>Manage team</Link> page to
          invite them. Once they accept the invite, you can select them below.
        </Text>
        <Text margin="20px 0px 10px" tag="p">
          <Link
            href={`${BASE_DOC_URL_VB}/publish/integration-publishing-requirements#7-2-integration-has-a-qualifying-team-member`}
            target="_blank"
          >
            Learn more about the qualifying team member requirement.
          </Link>
        </Text>
      </aside>
    </Surface>
  );
}
